import { useTheme } from '../lib/theme';
import { useTranslation } from '../i18n';

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const t = useTranslation();
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={t('theme.toggle')}
      title={t('theme.toggle')}
      className="theme-toggle"
    >
      {theme === 'dark' ? '☀' : '☾'}
      <style>{css}</style>
    </button>
  );
}

const css = `
.theme-toggle {
  width: 32px; height: 32px;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 1rem;
  border-radius: var(--radius-sm);
}
`;
